<template>
  <div class="side-bar__footer password-page">
    <div class="password-modal">
      <div class="header">
        <icon name="lock"></icon>
        {{ $t('passwordProtect.passwordProtected') }}
      </div>
      <div class="body">
        <p>"{{ passwordStatus.title }}" {{ $t('passwordProtect.requiresAPassword') }} </p>
        <p>{{ $t('passwordProtect.emailHelp') }}</p>
        <input autocomplete="envelope" class="password-input" type="password" :placeholder="$t('passwordProtect.password')" v-model="password" />
        <div class="validation-message" v-if="passwordEmpty">
          <icon name="times" height="16" width="16"></icon>
          <span class="text">{{ $t('passwordProtect.passwordEmpty') }}</span>
        </div>
        <div class="validation-message" v-else-if="passwordStatus.incorrect">
          <icon name="times" height="16" width="16"></icon>
          <span class="text">{{ $t('passwordProtect.passwordIncorrect') }}</span>
        </div>
        <app-button :action="submitPassword" class="password-button side-bar__button" :text="$t('passwordProtect.unlock')" iconName="unlock"></app-button>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton'

export default {
  name: 'PasswordProtected',
  components: {
    AppButton
  },
  props: {
    passwordStatus: Object,
    getEnvelope: Function
  },
  data () {
    return {
      password: '',
      passwordEmpty: false
    }
  },
  methods: {
    submitPassword () {
      if (!this.password) {
        this.passwordEmpty = true
      } else {
        this.passwordEmpty = false
        this.getEnvelope(this.password)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'

  .password-page
    position: absolute
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    height: 100%
    min-height: 100%
    background-color: #0098CE
    color: #555
    width: 100vw
    height: 100vh
    top: 0
    left: 0
    z-index: 1000

  .password-modal
    width: 295px
    margin: 5px
    background-color: #fff
    border-radius: 3px
    box-shadow: 0px 0px 10px #00000029
    padding: 20px

    .header
      font-weight: 600
      font-size: 20px

    input
      width: 100%

    button
      float: right

    .body
      font-size: 12px

    .password-button
      float: right
      margin-top: 10px

    .password-input
      padding: 8px 10px
      font-size: 14px

    .validation-message
      margin-top: 5px
      font-size: 0.8em
      font-weight: bold
      color: $color-error
      .text, svg
        vertical-align: middle
        display: inline-block

      .text
        max-width: calc(100% - 21px)

      svg
        margin-right: 5px
</style>
